module.exports = {
    STREAM: 'STREAM',  //live data
    QUERY: 'QUERY',     //db query
    REPLAY: 'REPLAY',  //HISTORY date
    SINGLE: 'SINGLE'    //ever response require single response
};


// WEBPACK FOOTER //
// ./src-client-lib/api/request-pattern-type.js